import { FETCH_CONTENT_SCHEMA_SUCCEEDED, FORCE_SHOW_END_TEST_MODAL, UPDATE_AB_TEST_MASTER_NAME, UPDATE_AB_TEST_VARIATION_NAME, UPDATE_AB_TEST_VARIANT_AI_FEATURES, UPDATE_AB_TEST_VARIANT_SUBJECT } from 'ContentEditorUI/redux/actions/actionTypes';
import { produce } from 'immer';
const abTestReducer = (state = {}, action) => produce(state, draft => {
  const {
    type,
    response,
    value
  } = action;
  switch (type) {
    case FETCH_CONTENT_SCHEMA_SUCCEEDED:
      {
        var _response$content$abT;
        draft.abTestId = response.content.abTestId;
        draft.abTestType = (_response$content$abT = response.content.abTestType) !== null && _response$content$abT !== void 0 ? _response$content$abT : null;
        draft.abStatus = response.content.abStatus;
        draft.abVariation = response.content.abVariation;
        return Object.assign(draft, response.abtest);
      }
    case UPDATE_AB_TEST_MASTER_NAME:
      {
        draft.master.name = value;
        return draft;
      }
    case UPDATE_AB_TEST_VARIATION_NAME:
      {
        draft.activeVariant.name = value;
        return draft;
      }
    case UPDATE_AB_TEST_VARIANT_SUBJECT:
      {
        var _draft$variations;
        const {
          variantId,
          subject
        } = action;
        const variantEmail = (_draft$variations = draft.variations) === null || _draft$variations === void 0 ? void 0 : _draft$variations.find(variant => (variant === null || variant === void 0 ? void 0 : variant.id) === variantId);
        if (variantEmail) {
          variantEmail.content.subject = subject;
        }
        return draft;
      }
    case UPDATE_AB_TEST_VARIANT_AI_FEATURES:
      {
        var _draft$variations2;
        const {
          variantId: id,
          aifeatures
        } = action;
        const variant = (_draft$variations2 = draft.variations) === null || _draft$variations2 === void 0 ? void 0 : _draft$variations2.find(v => (v === null || v === void 0 ? void 0 : v.id) === id);
        if (variant) {
          variant.content.aifeatures = aifeatures;
        }
        return draft;
      }
    case FORCE_SHOW_END_TEST_MODAL:
      {
        draft.forceEndAb = value;
        return draft;
      }
    default:
      return draft;
  }
});
export default abTestReducer;